module.exports = ".header_card {\n  font-family: \"Nunito\", sans-serif !important;\n  color: #6c757d !important;\n  font-size: 1.5rem !important;\n  font-weight: 700; }\n\n.strong {\n  font-weight: bold !important; }\n\n.page-title-btn {\n  margin-right: 15px; }\n\n.page-title-box {\n  margin-left: 15PX; }\n\n.btn-actions {\n  border: none;\n  overflow: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/fondeadores/detalles-inversion/detalles-inversion.component.scss
// module id = ./src/app/administracion/fondeadores/detalles-inversion/detalles-inversion.component.scss
// module chunks = main